import { DefinitionList, DefinitionListItem } from "@funcional/react-ui";
import { IntlDateTime } from "@funcional/react-intl-ui";
import { IProduct } from "@pbm/products/contracts";

export function ProductCard({ product }: { product: IProduct }) {
  return (
    <DefinitionList className="mb-8">
      <DefinitionListItem label="EAN">{product.ean}</DefinitionListItem>
      <DefinitionListItem label="Nome">{product.name}</DefinitionListItem>
      <DefinitionListItem label="Embalagem">
        {product.package}
      </DefinitionListItem>
      <DefinitionListItem label="Marca">{product.brand}</DefinitionListItem>
      <DefinitionListItem label="Indústria">
        {product.industryName}
      </DefinitionListItem>
      <DefinitionListItem label="Tipo do conteúdo">
        {product.contentType}
      </DefinitionListItem>
      <DefinitionListItem label="Quantidade na embalagem">
        {product.contentQuantity}
      </DefinitionListItem>
      <DefinitionListItem label="Criado em">
        <IntlDateTime value={product.createdAt} />
      </DefinitionListItem>
      <DefinitionListItem label="Atualizado em">
        <IntlDateTime value={product.updatedAt} />
      </DefinitionListItem>
    </DefinitionList>
  );
}
